import { cn } from "@/lib/utils";

export function CommunityIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-2 w-3 text-steel-gray", className)}
      viewBox="0 0 12 8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.654 5.715a2.079 2.079 0 014.158 0v.272a.455.455 0 01-.455.455H8.109a.455.455 0 01-.455-.455v-.272zm-6.841 0a2.079 2.079 0 014.157 0v.272a.455.455 0 01-.455.455H1.267a.455.455 0 01-.454-.455v-.272z"
        fill="currentColor"
      />
      <path
        d="M3.143 6.627a3.167 3.167 0 116.333 0v.414c0 .383-.31.694-.693.694H3.836a.693.693 0 01-.693-.694v-.414z"
        fill="currentColor"
      />
      <circle cx="9.733" cy="2.796" fill="currentColor" r="1.162" />
      <circle cx="2.891" cy="2.796" fill="currentColor" r="1.162" />
      <circle cx="6.312" cy="2.026" fill="currentColor" r="1.771" />
    </svg>
  );
}

export function DifficultyIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4 text-dark-raspberry", className)}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 4.64v3.135l3.21 1.653V6.12L.012 4.476A1.099 1.099 0 000 4.639zm4.262 5.33l3.213 1.653V8.316L4.262 6.663v3.306zM8 4.198L4.787 5.85 8 7.505l3.212-1.654L8 4.198zm.525 7.425l3.213-1.654V6.663L8.526 8.316v3.307zm7.464-7.147L12.79 6.12v3.307L16 7.774V4.64c0-.055-.004-.11-.012-.163zm-.681-.906l-3.045-1.567-3.212 1.653 3.212 1.654 3.2-1.647a1.402 1.402 0 00-.155-.092zm-4.096-2.108L8.692.165A1.518 1.518 0 007.998 0c-.24 0-.478.055-.692.165l-2.52 1.297L8 3.115l3.213-1.653zm-7.476.541L.692 3.571a1.395 1.395 0 00-.155.093L3.736 5.31l3.212-1.653-3.212-1.654zM0 11.453c0 .44.265.849.691 1.068h.001l2.518 1.297V10.51L0 8.858v2.595zm4.262 2.906l3.047 1.568c.054.028.11.052.166.073v-3.294l-3.213-1.654v3.307zM8.525 16a1.3 1.3 0 00.167-.073c.78-.401 1.906-.98 3.046-1.568v-3.307l-3.213 1.654V16zm4.266-2.182l2.518-1.297c.427-.22.692-.629.692-1.068V8.858l-3.21 1.653v3.307z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DurationIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-5 text-dark-raspberry", className)}
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M8.669 3.5h2.666c.367 0 .667.3.667.667 0 .366-.3.666-.667.666H8.67a.669.669 0 01-.667-.666c0-.367.3-.667.667-.667zm2 8c0 .367-.3.667-.667.667a.669.669 0 01-.667-.667V8.833c0-.366.3-.666.667-.666.366 0 .666.3.666.666V11.5zm4.02-3.74l.5-.5a.662.662 0 000-.933l-.007-.007a.662.662 0 00-.933 0l-.5.5a5.974 5.974 0 00-3.747-1.32c-3.2 0-5.92 2.64-6 5.84a5.999 5.999 0 006 6.16 5.996 5.996 0 004.687-9.74zM5.335 11.5a4.663 4.663 0 004.667 4.667 4.663 4.663 0 004.666-4.667 4.663 4.663 0 00-4.666-4.667A4.663 4.663 0 005.335 11.5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function PlayersIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-5 text-dark-raspberry", className)}
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M9.563 7.071A2.56 2.56 0 017 9.643 2.568 2.568 0 014.43 7.07 2.568 2.568 0 017 4.5a2.56 2.56 0 012.563 2.571zm6.856 0a2.56 2.56 0 01-2.562 2.572 2.568 2.568 0 01-2.572-2.572A2.568 2.568 0 0113.857 4.5a2.56 2.56 0 012.562 2.571zM7 11.357c-1.997 0-6 1.003-6 3v1.286a.86.86 0 00.857.857h10.286a.86.86 0 00.857-.857v-1.286c0-1.997-4.003-3-6-3zm6.025.043c.3-.026.583-.043.832-.043 1.997 0 6 1.003 6 3v1.286A.86.86 0 0119 16.5h-4.44c.094-.266.154-.557.154-.857v-1.286c0-1.26-.677-2.211-1.654-2.923a.096.096 0 01-.008-.01c-.007-.008-.015-.018-.027-.024z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function ScaryIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[17px] w-4 text-dark-raspberry", className)}
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M13.96.687A6.853 6.853 0 0116 5.543v6.848c0 .374-.255.623-.638.623-.382 0-.637-.25-.637-.623V9.403a4.93 4.93 0 01-.765.934l-3.634 3.548a.697.697 0 01-.446.187.697.697 0 01-.446-.187L7.65 12.142l-3.824 3.735c-.447.374-1.02.623-1.594.623-.637 0-1.147-.187-1.594-.623C.255 15.442 0 14.881 0 14.321c0-.623.191-1.12.637-1.556l4.271-4.172 8.16-7.906a.626.626 0 01.892 0zm-4.08 11.89l3.187-3.112c2.04-2.055 2.231-5.292.383-7.47L6.31 9.09l1.785 1.744 1.785 1.743z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
